<template>
  <div class="register-container">
    <h1 class="register-title">注册</h1>
    <div class="register-area">
      <form class="register-form" @submit.prevent="register">
        <div class="register-content">
          <div class="register-box">
            <input type="email" id="email" required placeholder=" " class="register-input" v-model="email">
            <label for="email" class="register-label">邮箱</label>
            <i class="ri-mail-fill register-icon"></i>
          </div>
          <div class="register-box">
            <input type="password" id="password" required placeholder=" " class="register-input" v-model="password">
            <label for="password" class="register-label">密码</label>
            <i class="ri-lock-fill register-icon"></i>
          </div>
          <div class="register-box">
            <input type="password" id="confirm-password" required placeholder=" " class="register-input" v-model="confirmPassword">
            <label for="confirm-password" class="register-label">确认密码</label>
            <i class="ri-lock-fill register-icon"></i>
          </div>
        </div>
        <button type="submit" class="register-button">注册</button>
      </form>
      <p class="register-switch">
        已有账号？
        <button @click="$emit('switch-to-login')" class="switch-button">立即登录</button>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: '',
      password: '',
      confirmPassword: '', // 新增确认密码字段
    };
  },
  methods: {
    register() {
      // 检查密码和确认密码是否一致
      if (this.password !== this.confirmPassword) {
        alert('密码和确认密码不一致，请重新输入！');
        return;
      }

      const users = JSON.parse(localStorage.getItem('users')) || [];
      const existingUser = users.find(user => user.email === this.email);
      if (existingUser) {
        alert('该邮箱已被注册，请使用其他邮箱！');
        return;
      }

      const newUser = {
        email: this.email,
        password: this.password,
      };
      users.push(newUser);
      localStorage.setItem('users', JSON.stringify(users));
      alert('注册成功！请登录。');
      this.$emit('switch-to-login');
      this.resetFields(); // 清空输入框
    },
    resetFields() {
      this.email = '';
      this.password = '';
      this.confirmPassword = ''; // 清空确认密码字段
    },
    setPageIcon() {
      const link = document.createElement('link');
      link.rel = 'icon';
      link.href = '/favicon.ico'; // 替换为你的图标路径
      document.head.appendChild(link);
    }
  },
  mounted() {
    this.setPageIcon();
    document.title = '注册 - 空想工作室';
    this.resetFields(); // 确保页面加载时清空输入框
  }
};
</script>

<style scoped>
.register-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.9); /* 半透明白色背景 */
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* 添加阴影 */
  width: 100%;
  max-width: 400px;
}

.register-title {
  font-size: 2rem;
  margin-bottom: 2rem;
  color: #333;
}

.register-area {
  width: 100%;
}

.register-form {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.register-content {
  display: grid;
  gap: 1rem;
}

.register-box {
  position: relative;
  width: 100%;
}

.register-input {
  width: 365px;
  padding: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
  transition: border-color 0.3s;
}

.register-input:focus {
  border-color: #007bff;
}

.register-label {
  position: absolute;
  top: 0.5rem;
  left: 1rem;
  transition: all 0.3s ease;
}

.register-input:focus + .register-label,
.register-input:not(:placeholder-shown) + .register-label {
  top: -1rem;
  font-size: 0.8rem;
  color: #007bff;
}

.register-icon {
  position: absolute;
  right: 1rem;
  top: 1rem;
  font-size: 1.2rem;
  color: #ccc;
}

.register-button {
  margin-top: 1rem;
  padding: 1rem;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  width: 100%;
}

.register-button:hover {
  background: #0056b3;
}

.register-switch {
  text-align: center;
  margin-top: 1rem;
}

.switch-button {
  background: none;
  border: none;
  color: #007bff;
  cursor: pointer;
  text-decoration: underline;
}
</style>
